function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5 48C28.8438 48 32.8594 46.9297 36.5469 44.7891C40.2344 42.6484 43.1484 39.7344 45.2891 36.0469C47.4297 32.3594 48.5 28.3438 48.5 24C48.5 19.6562 47.4297 15.6406 45.2891 11.9531C43.1484 8.26562 40.2344 5.35938 36.5469 3.23438C32.8594 1.07812 28.8438 0 24.5 0C20.1562 0 16.1406 1.07031 12.4531 3.21094C8.76562 5.35156 5.85156 8.26562 3.71094 11.9531C1.57031 15.6406 0.5 19.6562 0.5 24C0.5 28.3438 1.57031 32.3594 3.71094 36.0469C5.85156 39.7344 8.76562 42.6484 12.4531 44.7891C16.1406 46.9297 20.1562 48 24.5 48ZM24.5 44.625C21.6875 44.625 19.0156 44.0938 16.4844 43.0312C14.0156 41.9688 11.8281 40.4844 9.92188 38.5781C8.01562 36.6719 6.54688 34.4844 5.51562 32.0156C4.42188 29.4844 3.875 26.8125 3.875 24C3.875 21.1875 4.40625 18.5156 5.46875 15.9844C6.53125 13.5156 8.01562 11.3281 9.92188 9.42188C11.8281 7.51562 14.0156 6.04688 16.4844 5.01562C19.0156 3.92188 21.6875 3.375 24.5 3.375C27.3125 3.375 29.9844 3.90625 32.5156 4.96875C34.9844 6.03125 37.1719 7.51562 39.0781 9.42188C40.9844 11.3281 42.4531 13.5156 43.4844 15.9844C44.5781 18.5156 45.125 21.1875 45.125 24C45.125 26.8125 44.5938 29.4844 43.5312 32.0156C42.4688 34.4844 40.9844 36.6719 39.0781 38.5781C37.1719 40.4844 34.9844 41.9531 32.5156 42.9844C29.9844 44.0781 27.3125 44.625 24.5 44.625Z",
  fill: "#262F39"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 22.5,
  y: 18,
  width: 4,
  height: 18,
  rx: 2,
  fill: "#262F39"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 22.5,
  y: 12,
  width: 4,
  height: 4,
  rx: 2,
  fill: "#262F39"
});
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.d6b443d9742a165d7394abae814c98a0.svg";
export { ForwardRef as ReactComponent };